// WS2 amenity constants — mirrors server/constants/amenities.js.
// Keep in sync manually; these are intentionally duplicated for the client bundle.

export const WS2_AMENITY_SLUGS = [
    'LIGHTS',
    'PAVEMENT__ASPHALT__CONCRETE',
    'FENCED',
    'CAMERAS',
    'ROAMING_SECURITY',
    'FOOD_RESTAURANT_IN_AREA',
    'HOTEL_IN_AREA',
    'TRUCK_STOP_IN_AREA',
    'UBER_EATS_DOORDASH_GRUBHUB',
    'GRAVEL_MILLINGS',
];

export const WS2_AMENITY_NAMES = {
    LIGHTS:                      'Lights',
    PAVEMENT__ASPHALT__CONCRETE: 'Paved (Asphalt / Concrete)',
    FENCED:                      'Fenced',
    CAMERAS:                     'Security Cameras',
    ROAMING_SECURITY:            'Roaming Security',
    FOOD_RESTAURANT_IN_AREA:     'Food / Restaurant Nearby',
    HOTEL_IN_AREA:               'Hotel Nearby',
    TRUCK_STOP_IN_AREA:          'Truck Stop Nearby',
    UBER_EATS_DOORDASH_GRUBHUB:  'Delivery Services Available',
    GRAVEL_MILLINGS:             'Gravel / Millings',
};

export const WS2_PROPERTY_TYPES = [
    'Truck Stop',
    'Warehouse',
    'Commercial Lot',
    'Rest Area',
    'Stadium / Venue',
    'Other',
];

export const WS2_SURFACE_TYPES = [
    'Paved (Asphalt)',
    'Paved (Concrete)',
    'Gravel',
    'Gravel / Millings',
    'Dirt',
    'Mixed',
];
